import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@saucelabs/ds-typography';
import { Select, Option } from '@saucelabs/ds-inputs';

import languages from '../constantAppSettingsLanguages.json';
import { selectors as groupsSelectors } from '../../group';
import selectors from '../selectors';
import operations from '../operations';

type Language = typeof languages[0];

const Language: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const currentGroup = useSelector(groupsSelectors.currentGroupSelector);
  const isLoading = useSelector(selectors.isSettingsLoadingSelector);
  const settings = useSelector(groupsSelectors.currentGroupSettingsSelector);
  const currentLanguage = settings?.lang;

  const saveLanguage = useCallback((newLanguage: string) => {
    if (currentGroup) {
      void dispatch(operations.updateSettings({
        groupId: currentGroup.id,
        originalValues: {
          lang: currentLanguage,
        },
        settingsName: 'device language',
        updatedValues: {
          lang: newLanguage,
        },
      }));
    }
  }, [currentGroup, currentLanguage, dispatch]);

  return (
    <div className="flex flex-row items-baseline justify-between">
      <Typography className="min-w-16 text-high-emphasis font-semibold">
        Device Language
      </Typography>

      <div className="overflow-auto">
        <Select
          aria-label="Device Language"
          isDisabled={isLoading}
          onSelectionChange={saveLanguage}
          selectedKey={currentLanguage ?? null}
        >
          {languages.map((language) => (
            <Option key={language.iso}>{language.language}</Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default Language;
